import { render, staticRenderFns } from "./ModalShareFields.vue?vue&type=template&id=07d0b245&scoped=true&lang=html&"
import script from "./ModalShareFields.vue?vue&type=script&lang=js&"
export * from "./ModalShareFields.vue?vue&type=script&lang=js&"
import style0 from "./ModalShareFields.vue?vue&type=style&index=0&id=07d0b245&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d0b245",
  null
  
)

export default component.exports